<app-purple-api-error-wrapper [enabledErrorPages]="enableErrorPages" [loaderId]="loaderId" [reqConditions]="(tsvc.isInitialized | async)"></app-purple-api-error-wrapper>

<purple-loader height="500px" loaderPath="/assets/loaders/main-loader.json" [speed]="1.9" [loaderId]="loaderId"></purple-loader>